// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var alignmentWrapper = css({
  padding: "0 ".concat("var(--ds-space-100, 8px)"),
  display: 'flex',
  flexWrap: 'wrap',
  maxWidth: "".concat(3 * 32, "px")
});